import { gql } from 'graphql-request'

export namespace ReservationMutations {
  export function updateReservation() {
    return gql`
      mutation updateReservation($reservation: ReservationUpdateMutation) {
        updateReservation(reservation: $reservation)
      }
    `
  }
}
